import { Injectable } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { PortfolioService } from '../../portfolio/portfolio.service';
import { PortfolioModel } from '../../../shared/models/portfolio.model';

interface CachedPortfolio {
  id: number;
  model: PortfolioModel;
}

@Injectable({ providedIn: 'root' })
export class ExperienceDataService {
  private portfolioSubject = new BehaviorSubject<PortfolioModel | null>(null);
  readonly portfolio$ = this.portfolioSubject.asObservable();

  private plotSubject = new BehaviorSubject<any>(null);
  readonly plot$ = this.plotSubject.asObservable();

  private cached: CachedPortfolio | null = null;
  private currentId: number | null = null;

  constructor(private portfolioService: PortfolioService) {}

  load(id: number): void {
    if (this.currentId === id && this.cached) {
      this.portfolioSubject.next(this.cached.model);
      return;
    }
    this.currentId = id;
    this.portfolioSubject.next(null);
    this.plotSubject.next(null);

    this.portfolioService.viewItem(id).pipe(
      catchError(() => of(null)),
    ).subscribe((resp: any) => {
      if (!resp) return;
      const model = new PortfolioModel(resp);
      this.cached = { id, model };
      this.portfolioSubject.next(model);
    });

    this.portfolioService.fetchPerformancePlot(id).pipe(
      catchError(() => of(null)),
    ).subscribe((plot: any) => {
      this.plotSubject.next(plot);
    });
  }

  get portfolio(): PortfolioModel | null {
    return this.portfolioSubject.value;
  }

  get plot(): any {
    return this.plotSubject.value;
  }
}
